var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "226.3 563.1 144 129.4",
    enableBackground: "new 226.3 563.1 144 129.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.3,692.4c-1.7,0-3.2-0.6-4.4-1.8l-54.6-53.9c-8.2-7.8-12.8-18.5-12.9-30.1c-0.1-11.5,4.2-22.3,12.1-30.6 c7.8-8.3,18.5-12.9,30.1-13c0.1,0,0.3,0,0.4,0c11,0,21.5,4.1,29.5,11.5c6.5-5.9,14.4-9.8,23-11c2.1-0.3,4.2-0.5,6.2-0.5 c9.3,0,18.1,3,25.4,8.7c9.1,7.1,15,17.1,16.7,28.2c1.7,11.1-1.1,22.2-7.9,31.2c-1.2,2.2-3.1,4-4.5,5.4l-54.6,53.9 C301.5,691.8,299.9,692.4,298.3,692.4z M298.3,677.1l50.1-49.5c0.7-0.7,2.2-2.2,2.4-2.7l0-0.1l0.1-0.1c0.1-0.2,0.3-0.5,0.5-0.8 l0-0.1l0-0.1c4.9-6.3,6.9-14.1,5.7-22c-1.2-7.9-5.4-15-11.9-20c-5.2-4-11.3-6.1-17.8-6.1c-9.4,0-18.2,4.5-24.2,12.3 c-1.2,1.5-3.1,2.5-5,2.5c-0.2,0-0.4,0-0.6,0c-2.2-0.2-4.1-1.5-5.1-3.5l0,0c-0.2-0.5-1.5-1.7-2.1-2.4l-0.3-0.3 c-5.8-5.5-13.4-8.5-21.3-8.5c-8.2,0-15.8,3.2-21.4,9.1c-5.6,5.9-8.6,13.6-8.5,21.7c0.1,8.1,3.3,15.6,9,21l1.1,1v0.1L298.3,677.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.8db5a767.svg";
export { ForwardRef as ReactComponent };